module.exports = __webpack_public_path__ + "img/qyyg.a6f4a434.svg";